import * as React from 'react';
import { SVGProps } from 'react';

const IconPlaySizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path d="m11 6-8 5V1l8 5Z" />
  </svg>
);
export default IconPlaySizeXs;
